<template>
	<div class="xs-12 flex xs-center wrap md-pt2 pb10">
		<office-insurance-proposal-list
			v-if="view === 'proposal-list'"
			@toggleAddProposalModal="toggleModal('addProposal')"
			@editProposal="editProposal"
		></office-insurance-proposal-list>
		<component v-else :is="view" @showProposalList="view = 'proposal-list'" />
		<core-modal name="addProposal" :headline="$t('add_offer')">
			<div class="p4">
				<div class="fw7 mb4">{{ addProposalButtonText }}</div>
				<div class="mb6">
					<div class="xs-12">
						<div class="block pb2">
							<label for="proposalName">Proposal name</label>
						</div>
						<j-base-input-text
							v-model="proposalName"
							id="proposalName"
						></j-base-input-text>
					</div>
				</div>
				<j-button class="mt6" @click="handleAdd" :isLoading="isLoading"
					>Add</j-button
				>
			</div>
		</core-modal>
	</div>
</template>

<script>
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import JButton from "@/components/JButton"
import JBaseInputText from "@/components/JBaseInputText"
import CoreModal from "@/modules/core/components/CoreModal"
import OfficeInsuranceProposalList from "./OfficeInsuranceProposalList"
import ProposalOfficeInsurance from "./ProposalOfficeInsurance"
import debounce from "lodash.debounce"
import { Liquid } from "liquidjs"

export default {
	components: {
		JButton,
		CoreModal,
		JBaseInputText,
		OfficeInsuranceProposalList,
		ProposalOfficeInsurance
	},
	props: {
		addProposalButtonText: {
			type: String,
			default: "Add Proposal"
		},
		productTypeLabel: {
			type: String,
			default: "Product Type"
		},
		selectProductInsuranceType: {
			type: String
		}
	},
	data() {
		return {
			view: "proposal-list",
			proposal: {},
			isActionLoading: null,
			isLoading: false,
			proposalName: "",
			openModal: "",
			clauses: []
		}
	},
	methods: {
		handleAdd: debounce(async function() {
			if (!this.offerHasMultipleLayers) this.addProposalAndOffer()
			else {
				this.isLoading = true

				await this.addProposal({ name: this.proposalName })
				await this.addDefaultClauseAndFacts()

				this.$store.dispatch("caseManagement/fetchProposals", {
					caseId: this.$store.state.caseManagement.caseId
				})
				this.isLoading = true

				this.toggleModal("addProposal")
			}
		}, 600),

		editProposal(proposal) {
			console.log("SSSS")
			// Set in store
			this.$store.commit("caseManagement/SET_PROPOSAL_ID", proposal.id)
			this.$store.commit("caseManagement/SET_OFFER_ID", proposal.offerId)
			this.view = "ProposalOfficeInsurance"
		},
		toggleModal(typeId) {
			if (this.openModal === typeId) {
				this.openModal = ""
				this.$modal.hide(typeId)
			} else {
				this.openModal = typeId
				this.$modal.show(typeId)
			}
		},
		/**
		 * If no proposal and offer, create
		 */
		async init() {
			this.isLoading = true
			const proposal = this.$store.state.caseManagement?.proposals?.[0]
			const offer = this.$store.state.caseManagement?.proposals?.[0]
				?.basket?.[0]

			if (proposal && offer) {
				this.$store.commit("caseManagement/SET_PROPOSAL_ID", proposal?.id)
				this.$store.commit("caseManagement/SET_OFFER_ID", offer?.id)
				await this.$store.dispatch("caseManagement/fetchProposals", {
					caseId: this.$store.state.caseManagement.caseId,
					options: { currencyCodes: [] }
				})
			}

			this.isLoading = false
		},
		async addProposal(input = {}) {
			const query = gql`
				mutation addProposal($caseId: String!, $input: addProposalInput!) {
					addProposal(caseId: $caseId, input: $input) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					caseId: this.$store.state.caseManagement.caseId,
					input
				}
			})

			this.isLoading = false

			// Errors
			if (res?.data?.addProposal?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addProposal?.errors?.[0] || this.$t("errors.general")
				)
				return Promise.resolve(res)
			}

			return Promise.resolve(res)
		},

		async addOffer() {
			const query = gql`
				mutation addOfferToProposal(
					$caseId: String!
					$proposalId: String!
					$input: addOfferInput!
				) {
					addOfferToProposal(
						caseId: $caseId
						proposalId: $proposalId
						input: $input
					) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				input: {
					productId: {
						plan: "office_package",
						type: "office_package",
						version: null
					}
				}
			}

			const res = await api({
				query,
				variables
			})

			if (res?.data?.addOfferToProposal?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addOfferToProposal?.errors?.[0] ||
						this.$t("errors.general")
				)
				return Promise.resolve(res)
			}

			return Promise.resolve(res)
		},

		async addProposalAndOffer() {
			this.isLoading = true
			const res = await this.addProposal({ name: this.proposalName })
			this.$store.commit(
				"caseManagement/SET_PROPOSAL_ID",
				res?.data?.addProposal?.createdStatus?.id
			)
			const res2 = await this.addOffer()
			this.$store.commit(
				"caseManagement/SET_OFFER_ID",
				res2?.data?.addOfferToProposal?.createdStatus?.id
			)

			await this.addDefaultClauseAndFacts()

			await this.$store.dispatch("caseManagement/fetchProposals", {
				caseId: this.$store.state.caseManagement.caseId,
				options: { currencyCodes: [] }
			})
			this.isLoading = false
			this.toggleModal("addProposal")
		},

		async addDefaultClauseAndFacts() {
			const defaultClause = [
				"b5c22652-7aca-4c10-933b-850c87c72ff1",
				"d51cb9d9-438e-4034-a309-7ba209a55f22",
				"584dfbce-4602-48d5-ab22-97633c755f1d",
				"09e51a11-cd34-4c15-ab20-8572072c75f5",
				"3cbfcf19-0d10-47f3-8b6f-47b33a1c18ac",
				"fd3718ab-db86-49bf-87c0-f46dcb59fe85"
			]

			await this.fetchClauses()

			await Promise.all(
				defaultClause.map(id => {
					const clause = this.clauses.find(item => item.id === id)
					return this.addClause(clause)
				})
			)

			const defaultFacts = [
				{
					type: "disclosureToInsurers",
					value: {
						stringValue:
							"For an insurer to decide to take a risk and then to make an informed assessment of the risk it faces under a contract of insurance, (and hence calculate the premium it should charge) all relevant matters must be disclosed in the utmost good faith to it. The duty to make full and frank disclosure rests upon the party seeking insurance cover (or renewal or variation of it) and not upon the broker who acts on that party’s behalf."
					}
				},
				{
					type: "form",
					value: {
						stringValue:
							"To follow the terms and conditions of FWD Office Insurance policy wording as per expiring policy no. XXXXXX other than as amended or endorsed hereon"
					}
				},

				{
					type: "disclosureStatement",
					value: {
						stringValue:
							"ABCD Risk Management Limited (the “Company”) is remunerated for its services by the receipt of commission paid by insurers. Your agreement to proceed with this insurance transaction shall constitute your consent to the receipt of commission by the Company."
					}
				}
			]

			await Promise.all(defaultFacts.map(this.addFactToProposalOffer))
		},

		async addClause(clause) {
			const query = gql`
				mutation addClauseToProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: addClauseInput!
				) {
					addClauseToProposalOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						input: $input
					) {
						status
						errors
					}
				}
			`

			let variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.$store.state.caseManagement.offerId,
				input: {
					order: clause.order,
					templateId: clause.id,
					renderParameters: {
						name: "data",
						contentJsonString: JSON.stringify(
							this.parseHtmlToSchema(clause.html)
						)
					}
				}
			}

			await api({ query, variables })
		},

		async fetchClauses() {
			const query = gql`
				query fetchClauseTemplates($where: templateWhereInput) {
					templates(where: $where) {
						list {
							id
							name
							... on clauseHtml {
								html
								order
							}
						}
					}
				}
			`
			const variables = {
				where: {
					type: "clauseHtml"
				}
			}
			const res = await api({ query, variables })
			this.clauses = res?.data?.templates?.list
		},

		parseHtmlToSchema(htmlString) {
			// declare liquidjs
			const liquidjs = new Liquid()
			/**
			 * parse htmlstring into ast
			 * filter out html reference in ast, only get items with liquid syntax
			 * strip "data." from string
			 * convert into object
			 */
			return liquidjs
				.parse(htmlString)
				?.filter(item => item.hasOwnProperty("value"))
				?.map(item => ({
					key: item?.value?.initial?.replace("data.", ""),
					value: item?.value?.filters
						?.find(obj => obj.name === "default")
						?.args?.[0].replace(/'|"/g, "")
				}))
				?.reduce((obj, item) => {
					return {
						...obj,
						[item.key]: item.value
					}
				}, {})
		},

		async addFactToProposalOffer(input) {
			const query = gql`
				mutation addFactToProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: addFactInput!
				) {
					addFactToProposalOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						input: $input
					) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				offerId: this.$store.state.caseManagement.offerId,
				proposalId: this.$store.state.caseManagement.proposalId,
				input
			}

			await api({ query, variables })
		}
	},

	computed: {},

	mounted() {
		this.init()
	}
}
</script>

<style></style>
